import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'

export interface SettingState {
  donViList?: any
  donViBaoCaoList?: any
  danhMucList?: any
  khoNguonList?: any
  khoDichList?: any
}

const initialState: SettingState = {
  donViList: {},
  donViBaoCaoList: {},
  danhMucList: {},
  khoNguonList: {},
  khoDichList: {},
}

export const settingDucks = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    getListUnit: (state: RootState) => {
      state.donViList = { loading: true }
    },
    getListUnitSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.donViList = { loading: false, ...action.payload }
    },
    getListUnitFail: (state: RootState, action: PayloadAction<any>) => {
      state.donViList = { loading: false, ...action.payload }
    },

    getListUnitReport: (state: RootState) => {
      state.donViBaoCaoList = { loading: true }
    },
    getListUnitReportSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.donViBaoCaoList = { loading: false, ...action.payload }
    },
    getListUnitReportFail: (state: RootState, action: PayloadAction<any>) => {
      state.donViBaoCaoList = { loading: false, ...action.payload }
    },

    getListCategorie: (state: RootState) => {
      state.danhMucList = { loading: true }
    },
    getListCategorieSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.danhMucList = { loading: false, ...action.payload }
    },
    getListCategorieFail: (state: RootState, action: PayloadAction<any>) => {
      state.danhMucList = { loading: false, ...action.payload }
    },

    getListSourceWarehouse: (state: RootState) => {
      state.khoNguonList = { loading: true }
    },
    getListSourceWarehouseSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.khoNguonList = { loading: false, ...action.payload }
    },
    getListSourceWarehouseFail: (state: RootState, action: PayloadAction<any>) => {
      state.khoNguonList = { loading: false, ...action.payload }
    },

    getListDestinWarehouse: (state: RootState) => {
      state.khoDichList = { loading: true }
    },
    getListDestinWarehouseSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.khoDichList = { loading: false, ...action.payload }
    },
    getListDestinWarehouseFail: (state: RootState, action: PayloadAction<any>) => {
      state.khoDichList = { loading: false, ...action.payload }
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getListUnit,
  getListUnitSuccess,
  getListUnitFail,

  getListUnitReport,
  getListUnitReportSuccess,
  getListUnitReportFail,

  getListCategorie,
  getListCategorieSuccess,
  getListCategorieFail,

  getListSourceWarehouse,
  getListSourceWarehouseSuccess,
  getListSourceWarehouseFail,
  
  getListDestinWarehouse,
  getListDestinWarehouseSuccess,
  getListDestinWarehouseFail,
  
} = settingDucks.actions

export default settingDucks.reducer

